export default __webpack_public_path__ + "static/2393-c44ff25903361df7527d686e6ff3983a.gif";